import axios from 'axios';
import { get, some } from 'lodash-es';

import { getAuthToken } from '@/infra/auth';

// 权限拦截豁免接口列表
const AUTH_INTERCEPTOR_EXEMPTION = ['getLoginUser', 'logout'];

const request = axios.create({
    withCredentials: true,
    timeout: 1000000,
    responseType: 'json',
    validateStatus: (status) =>
        (status >= 200 && status < 300) || status === 304 || status == 204,
});

const addAuthInfo = (request) => {
    request.headers.Authorization = `Bearer ${getAuthToken()}`;

    return request;
};

const authInterceptor = (response) => {
    const code = get(response, 'data.code');
    const url = get(response, 'config.url');

    if (
        !some(AUTH_INTERCEPTOR_EXEMPTION, (exemption) =>
            url.includes(exemption),
        )
    ) {
        if (code === 401) {
            // 无权限，跳转到登录页
            window.location.href = '/login';
            return;
        }
    }

    // 返回原始错误，以便后续拦截器处理
    return Promise.resolve(response);
};

request.interceptors.request.use(addAuthInfo);
request.interceptors.response.use(authInterceptor);

// 格式化返回结果
request.interceptors.response.use(
    function (response) {
        const data = get(response, 'data');
        // 将响应头中的 Access-Token 附加到返回结果，供登录逻辑取用
        const accessToken = get(response, 'headers.access-token') || get(response, 'headers.Access-Token');
        if (accessToken && data && typeof data === 'object') {
            data.__accessToken = accessToken;
        }
        return data;
    },
    function (error) {
        return Promise.reject(error);
    },
);

export default request;
